import React from 'react';
import { HtmlTrans, SectionHeader, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';

const InstructionNotes = () => {
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader title={t('specialConsideration->>IndCoordinatorInstruction.NoteTile')} />
      <ol>
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>IndCoordinatorInstruction.Note1Title')}
          </Typography>
          <ul>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note1Content1')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note1Content2')}
              </Typography>
            </li>
          </ul>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>IndCoordinatorInstruction.Note2Title')}
          </Typography>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>IndCoordinatorInstruction.Note3Title')}
          </Typography>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>IndCoordinatorInstruction.Note4Title')}
          </Typography>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>IndCoordinatorInstruction.Note5Title')}
          </Typography>
          <ol type="a">
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note5Content1.Title')}
              </Typography>
              <ul>
                <li>
                  <Typography variant="body1">
                    {t('specialConsideration->>IndCoordinatorInstruction.Note5Content1.Part1')}
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    {t('specialConsideration->>IndCoordinatorInstruction.Note5Content1.Part2')}
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    <HtmlTrans i18nKey="specialConsideration->>IndCoordinatorInstruction.Note5Content1.Part3" />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    {t('specialConsideration->>IndCoordinatorInstruction.Note5Content1.Part4')}
                  </Typography>
                </li>
              </ul>
              <Typography variant="body1">
                <HtmlTrans i18nKey="specialConsideration->>IndCoordinatorInstruction.Note5Content1.Part5" />
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note5Content2')}
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note5Content3.Title')}
              </Typography>
              <ul>
                <li>
                  <Typography variant="body1">
                    <HtmlTrans i18nKey="specialConsideration->>IndCoordinatorInstruction.Note5Content3.Part1" />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    {t('specialConsideration->>IndCoordinatorInstruction.Note5Content3.Part2')}
                  </Typography>
                </li>
              </ul>
              <br />
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note5Content3.Part3')}
              </Typography>
              <br />
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note5Content3.Part4')}
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note5Content4.Part1')}
              </Typography>
              <br />
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note5Content4.Part2')}
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>IndCoordinatorInstruction.Note5Content5')}
              </Typography>
              <br />
            </li>
          </ol>
        </li>
        <br />
      </ol>
    </>
  );
};

export default InstructionNotes;
